<template>
  <div class="space-y-6">
    <div class="bg-white rounded-lg shadow p-6">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-bold">Surgeons</h2>
        <button @click="openForm()" type="button" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
          ➕ New Surgeon
        </button>
      </div>

      <div v-if="masterDataStore.loading" class="text-center py-12">
        <div class="inline-block spinner w-8 h-8"></div>
      </div>
      <div v-else-if="masterDataStore.surgeons.length === 0" class="text-center py-12 text-gray-500">
        No surgeons found
      </div>
      <div v-else class="overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-100 border-b">
            <tr>
              <th class="px-6 py-3 text-left text-sm font-semibold">ID</th>
              <th class="px-6 py-3 text-left text-sm font-semibold">Name</th>
              <th class="px-6 py-3 text-left text-sm font-semibold">Education</th>
              <th class="px-6 py-3 text-left text-sm font-semibold">Designation</th>
              <th class="px-6 py-3 text-left text-sm font-semibold">Working At</th>
              <th class="px-6 py-3 text-left text-sm font-semibold">Reg No</th>
              <th class="px-6 py-3 text-left text-sm font-semibold">Mobile</th>
              <th class="px-6 py-3 text-left text-sm font-semibold">Status</th>
              <th class="px-6 py-3 text-left text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody class="divide-y">
            <tr v-for="surgeon in masterDataStore.surgeons" :key="surgeon.id" class="hover:bg-gray-50">
              <td class="px-6 py-4 text-sm text-gray-500">{{ surgeon.id }}</td>
              <td class="px-6 py-4 text-sm font-medium">{{ surgeon.name }}</td>
              <td class="px-6 py-4 text-sm">{{ surgeon.education || '—' }}</td>
              <td class="px-6 py-4 text-sm">{{ surgeon.designation || '—' }}</td>
              <td class="px-6 py-4 text-sm">{{ surgeon.working_at || '—' }}</td>
              <td class="px-6 py-4 text-sm">{{ surgeon.reg_no || '—' }}</td>
              <td class="px-6 py-4 text-sm">{{ surgeon.mobile_no || '—' }}</td>
              <td class="px-6 py-4 text-sm">
                <span :class="['px-2 py-1 rounded text-xs', String(surgeon.is_active) === '1' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800']">
                  {{ String(surgeon.is_active) === '1' ? 'Active' : 'Inactive' }}
                </span>
              </td>
              <td class="px-6 py-4 text-sm space-x-2">
                <button @click="editSurgeon(surgeon)" class="text-blue-600 hover:text-blue-800">Edit</button>
                <button @click="deleteSurgeonFunc(surgeon.id)" class="text-red-600 hover:text-red-800">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Form Modal -->
    <div v-if="showForm" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 50;">
      <div style="background: white; padding: 24px; border-radius: 8px; width: 560px; max-height: 90vh; overflow-y: auto; position: relative; z-index: 51;">
        <h3 style="font-size: 18px; font-weight: bold; margin-bottom: 16px;">{{ editingItem ? 'Edit Surgeon' : 'New Surgeon' }}</h3>
        <form @submit.prevent="submitForm" style="display: flex; flex-direction: column; gap: 12px;">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
            <div>
              <label style="display: block; font-size: 14px; font-weight: 500; margin-bottom: 4px;">Name *</label>
              <input v-model="formData.name" required style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;" />
            </div>
            <div>
              <label style="display: block; font-size: 14px; font-weight: 500; margin-bottom: 4px;">Reg No</label>
              <input v-model="formData.reg_no" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;" />
            </div>
            <div>
              <label style="display: block; font-size: 14px; font-weight: 500; margin-bottom: 4px;">Education</label>
              <input v-model="formData.education" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;" />
            </div>
            <div>
              <label style="display: block; font-size: 14px; font-weight: 500; margin-bottom: 4px;">Designation</label>
              <input v-model="formData.designation" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;" />
            </div>
            <div style="grid-column: span 2;">
              <label style="display: block; font-size: 14px; font-weight: 500; margin-bottom: 4px;">Working At</label>
              <input v-model="formData.working_at" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;" />
            </div>
            <div>
              <label style="display: block; font-size: 14px; font-weight: 500; margin-bottom: 4px;">Mobile No</label>
              <input v-model="formData.mobile_no" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;" />
            </div>
            <div>
              <label style="display: block; font-size: 14px; font-weight: 500; margin-bottom: 4px;">Email</label>
              <input v-model="formData.email" type="email" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;" />
            </div>
          </div>
          <div style="display: flex; align-items: center;">
            <input v-model="formData.is_active" type="checkbox" id="active-check" />
            <label for="active-check" style="margin-left: 8px; font-size: 14px;">Active</label>
          </div>
          <div style="display: flex; gap: 12px; padding-top: 16px; border-top: 1px solid #ccc;">
            <button type="button" @click="closeForm" style="flex: 1; padding: 8px; border: 1px solid #ccc; border-radius: 4px; cursor: pointer;">Cancel</button>
            <button type="submit" style="flex: 1; padding: 8px; background: #2563eb; color: white; border: none; border-radius: 4px; cursor: pointer;">{{ editingItem ? 'Update' : 'Create' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Swal from 'sweetalert2'
import { useMasterDataStore } from '@/stores/masterDataStore'

const masterDataStore = useMasterDataStore()
const showForm = ref(false)
const editingItem = ref(null)
const formData = ref({ name: '', education: '', designation: '', working_at: '', reg_no: '', mobile_no: '', email: '', is_active: true })

const submitForm = async () => {
  try {
    if (!formData.value.name) {
      Swal.fire({ icon: 'warning', title: 'Missing Fields', text: 'Name is required', confirmButtonColor: '#3085d6' })
      return
    }
    const data = { ...formData.value, is_active: formData.value.is_active ? 1 : 0 }
    if (editingItem.value) {
      await masterDataStore.updateSurgeon(editingItem.value.id, data)
      Swal.fire({ icon: 'success', title: 'Success', text: 'Surgeon updated successfully', confirmButtonColor: '#3085d6' })
    } else {
      await masterDataStore.createSurgeon(data)
      Swal.fire({ icon: 'success', title: 'Success', text: 'Surgeon created successfully', confirmButtonColor: '#3085d6' })
    }
    closeForm()
    await masterDataStore.getSurgeons()
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response?.data?.message || masterDataStore.error || error.message || 'Failed to save',
      confirmButtonColor: '#3085d6'
    })
  }
}

const closeForm = () => {
  showForm.value = false
  editingItem.value = null
  formData.value = { name: '', education: '', designation: '', working_at: '', reg_no: '', mobile_no: '', email: '', is_active: true }
}

const openForm = () => { showForm.value = true }

const editSurgeon = (surgeon) => {
  editingItem.value = surgeon
  formData.value = {
    name: surgeon.name,
    education: surgeon.education || '',
    designation: surgeon.designation || '',
    working_at: surgeon.working_at || '',
    reg_no: surgeon.reg_no || '',
    mobile_no: surgeon.mobile_no || '',
    email: surgeon.email || '',
    is_active: String(surgeon.is_active) === '1'
  }
  showForm.value = true
}

const deleteSurgeonFunc = async (id) => {
  Swal.fire({
    title: 'Confirm Delete', text: 'Are you sure you want to delete this surgeon?', icon: 'warning',
    showCancelButton: true, confirmButtonColor: '#d33', cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it', cancelButtonText: 'Cancel'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await masterDataStore.deleteSurgeon(id)
        await masterDataStore.getSurgeons()
        Swal.fire({ icon: 'success', title: 'Deleted', text: 'Surgeon deleted successfully', confirmButtonColor: '#3085d6' })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Delete Failed',
          text: error.response?.data?.message || masterDataStore.error || 'Failed to delete surgeon',
          confirmButtonColor: '#3085d6'
        })
      }
    }
  })
}

onMounted(async () => {
  try {
    await masterDataStore.getSurgeons()
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response?.data?.message || masterDataStore.error || 'Failed to load surgeons',
      confirmButtonColor: '#3085d6'
    })
  }
})
</script>
